import React from 'react';
import { Box } from '@withjoy/joykit';
import { styled, useTheme } from '@withjoy/joykit/theme';
import { ChevronRight } from '@withjoy/joykit/icons';
import { STANDARD_TRANSITION } from '@shared/utils/animationTransition';

const StyledChevron = styled(ChevronRight)``;

export const GuestGuideActionButton = React.forwardRef<
  HTMLButtonElement,
  {
    children: React.ReactNode;
    icon: React.ReactNode;
    as?: 'button' | 'a';
    onClick?: () => void;
    href?: string;
  }
>(({ children, icon, as = 'button', ...props }, ref) => {
  const theme = useTheme();
  return (
    <Box
      ref={ref}
      as={as}
      typographyVariant={'button2'}
      width={'100%'}
      padding={4}
      display={'flex'}
      alignItems={'center'}
      gap={3}
      borderRadius="200px"
      boxShadow={`inset 0 0 0 1px ${theme.colors.mono5}`}
      transition={`all ${STANDARD_TRANSITION}`}
      _hover={{
        boxShadow: `inset 0 0 0 2px ${theme.colors.black}`,
        [StyledChevron]: {
          color: theme.colors.black,
        },
      }}
      // need to spread box props for trigger of Popover
      {...props}
    >
      {icon}
      <Box
        flex={1}
        display={'flex'}
        justifyContent={'flex-start'}
        alignItems={'center'}
      >
        {children}
      </Box>
      <StyledChevron
        transition={`color ${STANDARD_TRANSITION}`}
        size={'sm'}
        marginLeft={'auto'}
        color={theme.colors.mono14}
      />
    </Box>
  );
});
